import {checkPosition} from "../components/helpers";

export function initNewsMediaPageLanding() {

    const allNewsType = '0';
    const newsContainer = $('#news_container');
    const preloader = $('#news_media_preloader');
    const ajaxData = {
        pageNumber: 2,
        newsCount: 14,
        tags: [],
    };
    let newsTypeUrl = '/ajax/getNewsList/';
    let isLoading = false;
    let shouldNotLoad = false;
    let isGoodWingsLanding = false;

    // подгрузка опеределенного типа новостей в зависимости от страницы
    if ($('#good_wings_list_landing').length){
        newsTypeUrl = '/ajax/getNewsList/';
        isGoodWingsLanding = true;
    }
    if ($('#wings_tv_list_landing').length) ajaxData.newsTypeId = 3; // подгрузка опеределенного типа новостей в зависимости от страницы

    $('body').addClass('news-media');

    $('[data-news-tags] .tag').click(function() {
        $(this).toggleClass('active');
        shouldNotLoad = false;
        getCheckedTabsAndTags();
        ajaxData.pageNumber = 1;
        newsContainer.html('');
        getData();
    });

    $('[data-news-select]').select2({
        theme: 'default',
        minimumResultsForSearch: Infinity,
        $dropdownParent: $('[data-news-select]').parent()
    });


    $('[data-news-select]').change(function () {
        window.location.href = $(this).val();
    });

    $(window).scroll(function () {
        checkPosition(newsContainer, [getCheckedTabsAndTags, getData]);
    });

    function getCheckedTabsAndTags() {
        ajaxData.tags = [];

        $('[data-news-tags]').children().each(function(index, elem) {
            if ($(elem).hasClass('active')) {
                ajaxData.tags.push($(this).attr('data-tag-name'));
            }
        });

        if ($('#news_media_landing').length) {
            $('[data-news-tabs]').children().each(function(index, elem) {
                const ThisNewsType = $(elem).attr('data-news-type');
                const isActive = $(elem).hasClass('active');
                const isNotAllNews = ThisNewsType !== allNewsType;

                if (isActive && isNotAllNews)  ajaxData.newsTypeId = +ThisNewsType;
            });
        }
    }

    // выводим сообщение, если сервер вернул ошибку или неверные данные
    function renderErrorMessage() {
        const errorBlock =  `      
            <div class="col flex-direction-column">
                <h3 class="heading">Произошла неизвестная ошибка</h3>
                <p>Попробуйте перезагрузить страницу</p>
            </div>                     
        `;

        shouldNotLoad = true;
        newsContainer.html('');
        newsContainer.append(errorBlock);
    }

    function getData() {
    if (isLoading || shouldNotLoad) return;

    isLoading = true;
    preloader.removeClass('hide');

    //если запрос с Добрых Крыльев - tags всегда ["58"]
    if (isGoodWingsLanding){
        ajaxData.tags = ["58"];
    }

    $.ajax({
        url: newsTypeUrl,
        type: 'POST',
        contentType: 'application/json',
        dataType: 'html',
        data: JSON.stringify(ajaxData),
        success: (res) => {
            if (!res && !res.length) {
                shouldNotLoad = true;
            } else {
                newsContainer.append(res);
                ajaxData.pageNumber++;
            }

            isLoading = false;
            preloader.addClass('hide');
        },
        error: (res) => {
            renderErrorMessage();
            // newsContainer.append(mockData);
            isLoading = false;
            preloader.addClass('hide');
        },
    });
}

    var mockData = `
        <div class="col w-50-desktop w-100-xxs-desktop">
            <article class="item item-small image-covered">
                <img class="img lozad" data-src="https://img.freepik.com/free-photo/young-adult-man-doing-barbell-press-in-gym-dark-background-gym-training-workout_109427-2276.jpg?w=1380" alt="">
                <div class="text-content">
                    <div class="inscription">
                        <span class="content video">Видео</span>
                    </div>
                    <div class="date">
                        26 октября 2021
                    </div>
                    <h3 class="heading">
                        <a class="link" href="#">
                            <span class="link-text">
                                Динамо – Крылья Советов – 0:1
                            </span>
                        </a>
                    </h3>
                </div>
            </article>
            <article class="item item-small image-top">
                <img class="img lozad" data-src="https://img.freepik.com/free-photo/young-adult-man-doing-barbell-press-in-gym-dark-background-gym-training-workout_109427-2276.jpg?w=1380" alt="">
                <div class="text-content">
                    <div class="inscription">
                        <span class="content photo">фото</span>
                        <span class="content text">Команда</span>
                    </div>
                    <div class="date">
                        26 октября 2021
                    </div>
                    <h3 class="heading">
                        <a class="link" href="#">
                            <span class="link-text">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            </span>
                        </a>
                    </h3>
                </div>
            </article>
        </div>
         <div class="col w-50-desktop w-100-xxs-desktop">
            <article class="item item-small image-covered">
                <img class="img lozad" data-src="https://img.freepik.com/free-photo/young-adult-man-doing-barbell-press-in-gym-dark-background-gym-training-workout_109427-2276.jpg?w=1380" alt="">
                <div class="text-content">
                    <div class="inscription">
                        <span class="content video">Видео</span>
                    </div>
                    <div class="date">
                        26 октября 2021
                    </div>
                    <h3 class="heading">
                        <a class="link" href="#">
                            <span class="link-text">
                                Динамо – Крылья Советов – 0:1
                            </span>
                        </a>
                    </h3>
                </div>
            </article>
            <article class="item item-small image-top">
                <img class="img lozad" data-src="https://img.freepik.com/free-photo/young-adult-man-doing-barbell-press-in-gym-dark-background-gym-training-workout_109427-2276.jpg?w=1380" alt="">
                <div class="text-content">
                    <div class="inscription">
                        <span class="content photo">фото</span>
                        <span class="content text">Команда</span>
                    </div>
                    <div class="date">
                        26 октября 2021
                    </div>
                    <h3 class="heading">
                        <a class="link" href="#">
                            <span class="link-text">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            </span>
                        </a>
                    </h3>
                </div>
            </article>
        </div>
    `
}
